import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

function TablePagination(props) {
  const { page, totalPages, changePage } = props;
  const items = [];

  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === page}
        onClick={() => changePage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    <div className="pagination">
      <Pagination>{items}</Pagination>
    </div>
  );
}

export default TablePagination;
